import { createContext } from 'react';

interface IContext {
  selectedValues: string[];
}

export const SelectorDataListContext = createContext<IContext | null>(null);
